import AxiosInstance from "../services/networkServices";

export const getFilmFeed = async () => {
  const res = await AxiosInstance.get("/admin/film-feed");
  return res.data;
};

export const searchFilmFeed = async ({ q, kind }) => {
  const res = await AxiosInstance.get("/admin/film-feed/search", {
    params: { q, kind },
  });
  return res.data;
};

export const setFilmFeed = async (targets) => {
  const res = await AxiosInstance.put("/admin/film-feed", { targets });
  return res.data;
};

export const clearFilmFeed = async () => {
  const res = await AxiosInstance.delete("/admin/film-feed");
  return res.data;
};

export const restartFilmFeed = async () => {
  const res = await AxiosInstance.post("/admin/film-feed/restart");
  return res.data;
};

export const endActiveMatches = async () => {
  const res = await AxiosInstance.post("/admin/film-feed/end-active");
  return res.data;
};
